<template>
  <div class="loading">
    <div class="circle blue"></div>
    <div class="circle orange"></div>
    <div class="circle green"></div>
  </div>
</template>
